/**
 * @file useIdle.ts
 * @brief `true` once there has been no mouse, keyboard, wheel or touch input
 *        for `ms`; back to `false` on the next input.
 *
 * @details
 * For decorative motion that should go still when nobody is looking, e.g. a
 * desktop app left open on the login screen (DES 01-10-2026: "agar koi user app
 * open kar kay bhool gaya to yeh chalta rahay ga"). Used by the login's question
 * marquee and background video.
 *
 * @author DES
 * @date 01-10-2026
 */

import { useEffect, useState } from "react";

const EVENTS = ["pointermove", "pointerdown", "keydown", "wheel", "touchstart"] as const;

export function useIdle(ms: number): boolean {
  const [idle, setIdle] = useState(false);

  useEffect(() => {
    let timer = window.setTimeout(() => setIdle(true), ms);
    const wake = () => {
      setIdle(false);
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setIdle(true), ms);
    };
    for (const e of EVENTS) window.addEventListener(e, wake, { passive: true });
    return () => {
      window.clearTimeout(timer);
      for (const e of EVENTS) window.removeEventListener(e, wake);
    };
  }, [ms]);

  return idle;
}
